import { FuseSettingsConfigType } from "@fuse/core/FuseSettings/FuseSettings";

import themesConfig from "./configTema/configTema";

/**
 * O objeto settingsConfig é a configuração das definições (settings) da aplicação Fuse.
 */
const settingsConfig: FuseSettingsConfigType = {
	/**
	 * O objeto layout define o estilo e a configuração de layout da aplicação.
	 */
	layout: {
		/**
		 * A propriedade style define o estilo de layout da aplicação.
		 */
		style: "layout1", // layout1 layout2 layout3
		/**
		 * A propriedade config define a configuração do layout da aplicação.
		 * Veja exemplos de configs padrão em src/components/theme-layouts (ex.: src/components/theme-layouts/layout1/Layout1Config.js)
		 */
		config: {
			navbar: {
				style: "style-1",
			},
		}, // veja exemplos de configs padrão em src/components/theme-layouts (ex.: src/components/theme-layouts/layout1/Layout1Config.js)
	},

	/**
	 * A propriedade customScrollbars define se a aplicação deve usar scrollbars customizadas.
	 */
	customScrollbars: true,

	/**
	 * A propriedade direction define a direção do texto na aplicação.
	 */
	direction: "ltr", // rtl, ltr
	/**
	 * O objeto theme define o tema de cores da aplicação.
	 */
	theme: {
		main: themesConfig.default,
		navbar: themesConfig.navbar,
		toolbar: themesConfig.toolbar,
		footer: themesConfig.default,
	},

	/**
	 * A propriedade defaultAuth define os papéis de autorização padrão da aplicação.
	 * Para proteger o app inteiro por padrão, defina defaultAuth:['admin','staff','user']
	 * Para deixar o app inteiro acessível sem autorização por padrão, defina defaultAuth: null
	 * As rotas que possuírem auth configurado individualmente não serão sobrescritas.
	 */
	// "user" = marcador de autenticado cruzado por FuseUtils.hasPermission; deve coincidir com getUserPermissionName (utilitariosJwt.ts).
	defaultAuth: ["user"],

	/**
	 * A propriedade loginRedirectUrl define a URL de redirecionamento padrão após o login.
	 */
	loginRedirectUrl: "/",
};

export default settingsConfig;
